import React, { useEffect } from "react"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import { useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { connect } from "react-redux"
import toast from "react-hot-toast"
import axios from "axios"
import {
  existOperation,
  existDevelopment,
  getMessageWhatsapp,
  getPhonesText,
  makeItemsNav,
} from "../helpers/helper.rendering"
import { useLocation } from "@reach/router"

import {
  newSletterTokko,
  send_form_mediacore,
  updateFields,
} from "../redux/contactDucks"

import { Helmet } from "react-helmet"
import {
  getPropertiesAction,
  REDUX_UPDATE_FILTERS,
} from "../redux/propertiesDucks"
import {
  GET_CONFIGURATIONS_ACTION,
  GET_INVESTOR_ACTION,
} from "../redux/settingsDucks"

import ROUTES from "../../routes.js"
import { useGetDevelopmentsQuery } from "../redux/middlewareTokkoApi/developments"
import { useGetTotalFiltersQuery } from "../redux/originalTokkoApi/properties"
import { useGetConfigurationsQuery } from "../redux/mediacore/configuration"
import useQuerySummary from "../hooks/useQuerySummary"
import { useGetJobsQuery } from "../redux/mediacore/jobs.js"

const Footer = ({
  filters,
  api_key,
  investor,
  curFilters,
  development,
  property,
  novelties,
  dispatch,
}) => {
  const [open, setOpen] = useState(false)
  const isBrowser = typeof window !== "undefined"
  const location = useLocation()
  const pathname = location.pathname.split("/")[1]

  const [flag, setFlag] = useState(false)

  const {
    SALE_VIEW_DATA: SALE,
    RENT_VIEW_DATA: RENT,
    TEMPORARY_VIEW_DATA: TEMPORARY,
  } = JSON.parse(process.env.extra_data || ROUTES)
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        template_version
        proFeatures {
          compare
        }
        keys {
          tokko
        }
        env {
          APISERVER
          TENANTID
          CLIENTID
        }
        proFeatures {
          branchesWa
        }
        design {
          icons
        }
        logo
        global_email
        fiscal_data
        bot_cliengo
        global_whatsapp
        global_phone
        global_broker_id
        keys {
          captcha
        }
        social {
          facebook
          instagram
          linkedin
          youtube
          twitter
          tiktok
        }
        branch_office {
          name
          address
          city
          region
          broker_id
          contact {
            phone
            mail
            whatsapp
          }
        }
        sections {
          services {
            form
          }
          footer {
            title_contact
            title_social
            title_newsletter
            title_office
            button_contact {
              link
              value
            }
          }
        }
      }
    }
  `)

  const [closeWhatsapp, setCloseWhatsapp] = useState(true)

  const {
    design: { icons },
    env,
  } = realEstate
  const { template_version, proFeatures } = realEstate
  const { form: ServicesEnabled } = realEstate.sections.services
  const iconsStyle =
    icons === "Solid" || icons === "Light" ? `-${icons.toLowerCase()}` : ""
  const MediaPro = proFeatures.compare ? true : false
  const { branchesWa } = proFeatures
  const [disabled, setDisabled] = useState(true)

  const { data: modules } = useGetConfigurationsQuery(env.CLIENTID)
  const { data: allDevelopmentsData } = useGetDevelopmentsQuery(
    realEstate.keys.tokko
  )
  const { allSummaryData, isLoading } = useQuerySummary()
  const { data: allJobsData } = useGetJobsQuery(env.CLIENTID)

  const INVESTOR_CONFIGURATION = modules?.find(
    config => config.module === "INVESTOR"
  )
  const OWNER_CONFIGURATION = modules?.find(config => config.module === "OWNER")
  const BLOG_CONFIGURATION = modules?.find(config => config.module === "BLOG")

  const [datos, setDatos] = useState({
    email: "",
  })

  const handleInputChange = e => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    })
  }
  const sendForm = e => {
    e.preventDefault()
    if (realEstate.keys.tokko) {
      dispatch(newSletterTokko())
      dispatch(
        send_form_mediacore("newsletter", datos, realEstate.env.CLIENTID)
      )
    } else {
      dispatch(
        send_form_mediacore("newsletter", datos, realEstate.env.CLIENTID)
      )
    }
    document.getElementById("formNewsletter").reset()
    return toast.success("Te suscribiste a nuestro newsletter correctamente.")
  }

  useEffect(() => {
    const update = () => {
      dispatch(updateFields(datos))
    }
    update()
    if (!realEstate?.keys?.captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [datos])

  const callCliengo = () => {
    if (!flag) {
      var ldk = document.createElement("script")
      ldk.type = "text/javascript"
      ldk.async = true
      ldk.src = realEstate.bot_cliengo
      var s = document.getElementsByTagName("script")[0]
      s.parentNode.insertBefore(ldk, s)
      setFlag(true)
    }
  }

  const checkActive = _pathname => {
    if (_pathname === "inicio" && pathname === "") {
      return true
    }
    if (
      curFilters.operation === "alquiler-temporario" &&
      _pathname === "alquiler temp."
    ) {
      return true
    }
    if (
      ((_pathname === "venta" ||
        (_pathname === "alquiler" && _pathname !== "alquiler temp.")) &&
        pathname.includes("venta")) ||
      pathname.includes("alquiler")
    ) {
      if (curFilters.operation === "alquiler" && _pathname === "alquiler") {
        return true
      }
      if (curFilters.operation === "venta" && _pathname === "venta") {
        return true
      }
    } else {
      if (pathname === _pathname) {
        return true
      }
    }
    return false
  }

  const staticBody = () => {
    var body = document.body
    body.classList.remove("overflow-hidden")
  }

  const fillFilters = item => {
    return {
      location: [],
      type: [],
      operation: item,
      environments: "",
      bedrooms: "",
      address: "",
      price: {
        type: "",
        priceMin: "",
        priceMax: "",
      },
      surface: {
        type: "",
        surfaceMin: "",
        surfaceMax: "",
      },
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    }
  }

  const get_whatsApp_element = () => {
    if (
      pathname.includes(SALE.route) ||
      pathname.includes(RENT.route) ||
      pathname.includes(TEMPORARY.route)
    ) {
      return null
    }
    if (branchesWa) {
      if (realEstate.branch_office.length === 0) {
        return (
          <>
            <a
              href={
                "https://api.whatsapp.com/send?text=" +
                getMessageWhatsapp(development, property, location?.href) +
                "&phone=" +
                realEstate.branch_office[0].contact.whatsapp[0]
                  .replaceAll(" ", "")
                  .replaceAll("-", "")
                  .replaceAll("+", "")
              }
              target="_blank"
              class={"icon-whatsapp contact-btn d-none d-lg-flex "}
            ></a>
            <a
              href={
                "https://api.whatsapp.com/send?text=" +
                getMessageWhatsapp(development, property, location?.href) +
                "&phone=" +
                realEstate.branch_office[0].contact.whatsapp[0]
                  .replaceAll(" ", "")
                  .replaceAll("-", "")
                  .replaceAll("+", "")
              }
              target="_blank"
              class={"icon-whatsapp contact-btn d-flex d-lg-none "}
            ></a>
          </>
        )
      } else {
        return (
          <>
            <div
              onClick={() => setCloseWhatsapp(!closeWhatsapp)}
              class={
                "icon-whatsapp contact-btn d-lg-flex div-whatsapp " +
                (closeWhatsapp ? "close" : "open")
              }
            >
              <div
                className={
                  "float-whatsapp " +
                  (realEstate.branch_office.length === 1 ? "only-one" : "")
                }
              >
                {realEstate.branch_office.slice(0, 2).map(
                  (element, index) =>
                    element.contact.whatsapp.length > 0 && (
                      <>
                        <a
                          href={
                            "https://api.whatsapp.com/send?text=" +
                            getMessageWhatsapp(
                              development,
                              property,
                              location?.href
                            ) +
                            "&phone=" +
                            element.contact.whatsapp[0]
                              .replaceAll(" ", "")
                              .replaceAll("-", "")
                              .replaceAll("+", "")
                          }
                          target="_blank"
                          class={"contact-btn d-none d-lg-flex "}
                        >
                          {element.name}
                        </a>
                        <a
                          href={
                            "https://api.whatsapp.com/send?text=" +
                            getMessageWhatsapp(
                              development,
                              property,
                              location?.href
                            ) +
                            "&phone=" +
                            element.contact.whatsapp[0]
                              .replaceAll(" ", "")
                              .replaceAll("-", "")
                              .replaceAll("+", "")
                          }
                          target="_blank"
                          class={"contact-btn d-flex d-lg-none "}
                        >
                          {element.name}
                        </a>
                      </>
                    )
                )}
              </div>
            </div>
          </>
        )
      }
    } else {
      return (
        <>
          <a
            href={
              "https://api.whatsapp.com/send?text=" +
              getMessageWhatsapp(development, property, location?.href) +
              "&phone=" +
              realEstate.global_whatsapp
                .replaceAll(" ", "")
                .replaceAll("-", "")
                .replaceAll("+", "")
            }
            target="_blank"
            class={"icon-whatsapp contact-btn d-none d-lg-flex "}
          ></a>
          <a
            href={
              "https://api.whatsapp.com/send?text=" +
              getMessageWhatsapp(development, property, location?.href) +
              "&phone=" +
              realEstate.global_whatsapp
                .replaceAll(" ", "")
                .replaceAll("-", "")
                .replaceAll("+", "")
            }
            target="_blank"
            class={"icon-whatsapp contact-btn d-flex d-lg-none "}
          ></a>
        </>
      )
    }
  }

  const getCurrentYear = () => new Date().getFullYear()

  return realEstate.sections && pathname !== "contacto" ? (
    <>
      {isBrowser && (
        <Helmet>{realEstate.bot_cliengo ? callCliengo() : ""}</Helmet>
      )}
      <div className="sup-footer">
        <div className="container-fluid">
          <div
            class={
              "fixed-bar position-fixed " +
              (realEstate.global_whatsapp === "" && !branchesWa && "d-none")
            }
          >
            <div
              className={
                (MediaPro && "pulse-border ") +
                ((pathname.includes(RENT.route) ||
                  pathname.includes(SALE.route) ||
                  pathname.includes(TEMPORARY.route)) &&
                  "d-none")
              }
            ></div>
            {get_whatsApp_element()}
          </div>
          <div className="row">
            <div className="col-12 mb-lg-5 mb-0 order-lg-1 order-1">
              <div className="row">
                <div className="col-lg-4 order-1">
                  <div className="item-contact row mb-lg-0">
                    <h5 className="col-lg-12 col-4">
                      {realEstate?.sections?.footer?.title_contact}
                    </h5>
                    <div className="col-lg-12 col-8">
                      <a
                        target="_blank"
                        className="hover-footer-link mb-0 mb-lg-0"
                        href={"mailto:" + realEstate?.global_email}
                      >
                        {realEstate?.global_email}
                      </a>
                      {realEstate?.global_phone?.map(phone => (
                        <p
                          className={
                            "mb-0 mb-lg-0 " + (phone === "" ? "d-none" : "")
                          }
                        >
                          Teléfono {phone}
                        </p>
                      ))}
                      {realEstate?.global_broker_id.map((broker, index) => (
                        <p
                          className={
                            "mb-0 mb-lg-0 " + (broker === " " && "d-none")
                          }
                        >
                          {broker}
                        </p>
                      ))}
                      {!investor.id && (
                        <>
                          <Link
                            className="d-none d-lg-none btn btn-blue mt-5"
                            to={
                              realEstate?.sections?.footer?.button_contact.link
                            }
                          >
                            {realEstate?.sections?.footer?.button_contact.value}
                          </Link>
                          <Link
                            className="btn btn-blue d-lg-inline-block d-none mt-5"
                            to={
                              realEstate?.sections?.footer?.button_contact?.link
                            }
                          >
                            {realEstate?.sections?.footer.button_contact.value}
                          </Link>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-xxl-3 d-none d-lg-block order-2">
                  {realEstate.branch_office.length > 0 && (
                    <div className="item-contact row d-none d-lg-block">
                      <h5 className="col-lg-12 col-4">
                        {realEstate.sections?.footer?.title_office}{" "}
                        {realEstate.branch_office[0].name}
                      </h5>
                      <div className="col-lg-12 col-8">
                        <p>{realEstate.branch_office[0].address} </p>
                        <p>{realEstate.branch_office[0].region}</p>
                        <a
                          target="_blank"
                          className={
                            "hover-footer-link " +
                            (!realEstate.branch_office[0].contact.mail &&
                              "d-none")
                          }
                          href={
                            "mailto:" + realEstate.branch_office[0].contact.mail
                          }
                        >
                          {realEstate.branch_office[0].contact.mail}
                        </a>
                        {realEstate.branch_office[0].contact.phone.map(
                          phone => (
                            <p>Teléfono {phone}</p>
                          )
                        )}
                        {realEstate.branch_office[0].contact.whatsapp.map(
                          whatsapp => (
                            <a
                              className={"hover-footer-link"}
                              target="_blank"
                              href={
                                "https://api.whatsapp.com/send?" +
                                "phone=" +
                                whatsapp
                                  .replaceAll(" ", "")
                                  .replaceAll("-", "")
                                  .replaceAll("+", "")
                              }
                            >
                              Whatsapp {whatsapp}
                            </a>
                          )
                        )}
                        <p
                          className={
                            realEstate.branch_office[0].broker_id === "" &&
                            "d-none"
                          }
                        >
                          Matrícula {realEstate.branch_office[0].broker_id}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-4 offset-xxl-1 pl-lg-4 order-3 d-none d-lg-block">
                  <div className="item-contact row mb0">
                    <h5 className="col-lg-12 col-4">
                      {realEstate?.sections?.footer?.title_social}
                    </h5>
                    <div className="col-lg-12 col-8">
                      <a
                        target="_blank"
                        href={realEstate.social.instagram}
                        class={
                          realEstate.social.instagram ? "d-inline" : "d-none"
                        }
                      >
                        <i class={`icon-instagram${iconsStyle}`}></i>
                      </a>
                      <a
                        target="_blank"
                        href={realEstate.social.facebook}
                        class={
                          realEstate.social.facebook ? "d-inline" : "d-none"
                        }
                      >
                        <i class={`icon-facebook${iconsStyle}`}></i>
                      </a>
                      <a
                        target="_blank"
                        href={realEstate.social.linkedin}
                        class={
                          realEstate.social.linkedin ? "d-inline" : "d-none"
                        }
                      >
                        <i class={`icon-linkedin${iconsStyle}`}></i>
                      </a>
                      <a
                        target="_blank"
                        href={realEstate.social.youtube}
                        class={
                          realEstate.social.youtube ? "d-inline" : "d-none"
                        }
                      >
                        <i class={`icon-youtube${iconsStyle}`}></i>
                      </a>
                      <a
                        target="_blank"
                        href={realEstate.social.twitter}
                        class={
                          realEstate.social.twitter ? "d-inline" : "d-none"
                        }
                      >
                        <i class={`icon-twitter${iconsStyle}`}></i>
                      </a>
                      <a
                        target="_blank"
                        href={realEstate.social.tiktok}
                        class={realEstate.social.tiktok ? "d-inline" : "d-none"}
                      >
                        <i class={`icon-tiktok${iconsStyle}`}></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 order-lg-2 order-4">
              <div
                className={
                  "item-contact row mb-0 button-separator " +
                  (INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module
                    ? "d-block"
                    : " d-none")
                }
              >
                <h5 className="">ACCESOS PRIVADOS</h5>
                {INVESTOR_CONFIGURATION?.module && (
                  <div className="d-block">
                    <a
                      className="btn btn-investor mb-2 d-block d-lg-inline-block"
                      target={"_blank"}
                      href={INVESTOR_CONFIGURATION.url_login}
                    >
                      {INVESTOR_CONFIGURATION.text_cta || "INVERSORES"}
                    </a>
                  </div>
                )}
                {OWNER_CONFIGURATION?.module && (
                  <div className="d-block">
                    <a
                      className="btn btn-investor mb-2 d-block d-lg-inline-block"
                      target={"_blank"}
                      href={OWNER_CONFIGURATION.url_login}
                    >
                      {OWNER_CONFIGURATION.text_cta || "PROPIETARIOS"}
                    </a>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-xxl-3 order-lg-4 order-2 ">
              {realEstate.branch_office.length > 0 &&
                realEstate.branch_office.map((branch, index) => (
                  <div
                    className={
                      "item-contact row " +
                      (index > 0 ? "d-block" : "d-lg-none d-flex")
                    }
                  >
                    <h5 className="col-xxl-9 col-lg-12 col-4">
                      {realEstate.sections?.footer?.title_office} {branch.name}
                    </h5>
                    <div className="col-xxl-9 col-lg-12 col-8">
                      <p>{branch.address}</p>
                      <p>{branch.region}</p>
                      <a
                        target="_blank"
                        className={
                          "hover-footer-link " +
                          (!branch.contact.mail && "d-none")
                        }
                        href={"mailto:" + branch.contact.mail}
                      >
                        {branch.contact.mail}
                      </a>
                      {branch.contact.phone.map(phone => (
                        <p>Teléfono {phone}</p>
                      ))}
                      {branch.contact.whatsapp.map(whatsapp => (
                        <a
                          className={"hover-footer-link"}
                          target="_blank"
                          href={
                            "https://api.whatsapp.com/send?" +
                            "phone=" +
                            whatsapp
                              .replaceAll(" ", "")
                              .replaceAll("-", "")
                              .replaceAll("+", "")
                          }
                        >
                          Whatsapp {whatsapp}
                        </a>
                      ))}
                      <p className={branch.broker_id === "" && "d-none"}>
                        Matrícula {branch.broker_id}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
            <div className="d-block d-lg-none order-3">
              <div className="item-contact row mb0">
                <h5 className="col-lg-12 col-4">
                  {realEstate?.sections?.footer?.title_social}
                </h5>
                <div className="col-lg-12 col-8">
                  <a
                    target="_blank"
                    href={realEstate.social.instagram}
                    class={realEstate.social.instagram ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-instagram${iconsStyle}`}></i>
                  </a>
                  <a
                    target="_blank"
                    href={realEstate.social.facebook}
                    class={realEstate.social.facebook ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-facebook${iconsStyle}`}></i>
                  </a>
                  <a
                    target="_blank"
                    href={realEstate.social.linkedin}
                    class={realEstate.social.linkedin ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-linkedin${iconsStyle}`}></i>
                  </a>
                  <a
                    target="_blank"
                    href={realEstate.social.youtube}
                    class={realEstate.social.youtube ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-youtube${iconsStyle}`}></i>
                  </a>
                  <a
                    target="_blank"
                    href={realEstate.social.twitter}
                    class={realEstate.social.twitter ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-twitter${iconsStyle}`}></i>
                  </a>
                  <a
                    target="_blank"
                    href={realEstate.social.tiktok}
                    class={realEstate.social.tiktok ? "d-inline" : "d-none"}
                  >
                    <i class={`icon-tiktok${iconsStyle}`}></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 offset-xxl-1 order-lg-5 order-5">
              <div
                className={
                  "content-contact mt-auto " +
                  (investor.id ? "" : "enabled-border")
                }
              >
                <h5>{realEstate.sections?.footer?.title_newsletter}</h5>
                <form onSubmit={sendForm} id="formNewsletter">
                  <div className="d-flex mb-lg-3">
                    <input
                      type="email"
                      onChange={handleInputChange}
                      name="email"
                      required
                      placeholder="Ingresá tu mail"
                      className="mr-2"
                    />
                    <button
                      disabled={disabled}
                      type="submit"
                      className="submit icon-arrow"
                    ></button>
                  </div>
                  {realEstate?.keys?.captcha ? (
                    <ReCAPTCHA
                      sitekey={
                        realEstate?.keys?.captcha
                          ? realEstate?.keys?.captcha
                          : 0
                      }
                      onChange={() => setDisabled(false)}
                    />
                  ) : (
                    ""
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-2 d-flex d-lg-block align-items-start flex-column">
              <div className="logo-footer mx-auto mx-lg-0">
                <Link to="/">
                  <img src={realEstate.logo}></img>
                </Link>
                {/* CAMBIAR POR REALESTATE.LOGO */}
              </div>
            </div>
            <div className="col-5 col-lg-9 d-lg-flex d-none align-items-center justify-content-evenly">
              {makeItemsNav(
                allDevelopmentsData,
                allSummaryData,
                novelties,
                MediaPro,
                allJobsData,
                ServicesEnabled
              ).map((item, index) => (
                <li
                  onClick={() =>
                    staticBody() +
                    (item.name.toLowerCase() === "venta" ||
                    item.name.toLowerCase() === "alquiler" ||
                    item.name.toLowerCase() === "alquiler temp."
                      ? dispatch(
                          REDUX_UPDATE_FILTERS(
                            fillFilters(item.name),
                            item.name
                          )
                        ) + setOpen(false)
                      : //  +
                        // dispatch(getPropertiesAction())
                        dispatch(
                          REDUX_UPDATE_FILTERS(fillFilters("venta"), "venta")
                        ))
                  }
                  className={
                    checkActive(item.name.toLowerCase()) ? "active" : ""
                  }
                >
                  {item.name === RENT.name ||
                  item.name === SALE.name ||
                  item.name === TEMPORARY.name ? (
                    <a
                      className={
                        "text-uppercase is-a " +
                        (checkActive(item.name.toLowerCase()) ? "active" : "")
                      }
                      href={item.link}
                    >
                      {item.name}{" "}
                      {/* <span>
                                  {index < 9 ? "0" : ""}
                                  {index + 1}
                                </span> */}
                    </a>
                  ) : (
                    <Link
                      onClick={() => staticBody() + setOpen(false)}
                      className=""
                      to={item.link}
                    >
                      {item.name}{" "}
                    </Link>
                  )}
                </li>
              ))}
            </div>
            <div
              className="col-1 d-lg-flex d-none"
              style={{ justifyContent: "flex-end", alignContent: "center" }}
            >
              <div className="" style={{ right: 0, bottom: 0 }}>
                {realEstate?.fiscal_data ? (
                  <a
                    className="qr d-flex justify-content-end"
                    href={realEstate?.fiscal_data}
                    target="_F960AFIPInfo"
                  >
                    <img
                      src="http://www.afip.gob.ar/images/f960/DATAWEB.jpg"
                      border="0"
                    />
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-12 mt-5 d-lg-none">
              <div className="row">
                <div className="col-6">
                  {makeItemsNav(
                    allDevelopmentsData,
                    allSummaryData,
                    novelties,
                    MediaPro,
                    allJobsData,
                    ServicesEnabled
                  ).map(
                    (item, index) =>
                      index < 5 && (
                        <li
                          className={
                            pathname ===
                            item.link.replaceAll("/", "").toLowerCase()
                              ? "active "
                              : ""
                          }
                        >
                          <Link
                            onClick={() => staticBody() + setOpen(false)}
                            className=""
                            to={item.link}
                          >
                            {item.name}{" "}
                          </Link>
                        </li>
                      )
                  )}
                </div>
                <div className="col-6 d-flex flex-column">
                  {makeItemsNav(
                    allDevelopmentsData,
                    allSummaryData,
                    novelties,
                    MediaPro,
                    allJobsData,
                    ServicesEnabled
                  ).map(
                    (item, index) =>
                      index >= 5 && (
                        <li
                          className={
                            pathname ===
                            item.link.replaceAll("/", "").toLowerCase()
                              ? "active "
                              : ""
                          }
                        >
                          <Link
                            onClick={() => staticBody() + setOpen(false)}
                            className=""
                            to={item.link}
                          >
                            {item.name}{" "}
                          </Link>
                        </li>
                      )
                  )}
                  <div className="mt-auto d-block d-lg-none mt-auto">
                    {realEstate?.fiscal_data ? (
                      <a
                        className="qr d-flex justify-content-start"
                        href={realEstate?.fiscal_data}
                        target="_F960AFIPInfo"
                      >
                        <img
                          src={"http://www.afip.gob.ar/images/f960/DATAWEB.jpg"}
                          border="0"
                        />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-start d-lg-none text-center justify-content-center mt-5">
            <p className="copy">
              Promoted by{" "}
              <a
                target="_blank"
                className="normal-color"
                href="https://mediahaus.com.ar"
              >
                {" "}
                MediaHaus
              </a>{" "}
              - Powered by{" "}
              <a target="_blank" href="https://mediacore.app/">
                {" "}
                MediaCore
              </a>
              <br />
              <span style={{ fontSize: "0.7rem" }}>
                Todos los derechos reservados ® {getCurrentYear()}
              </span>
            </p>
          </div>
          <div className="row py-lg-5 d-none d-lg-flex justify-content-between align-items-end">
            <div className="col-lg-12 col-12 text-center justify-content-center d-lg-flex align-items-start">
              <p className="copy">
                Promoted by{" "}
                <a
                  target="_blank"
                  className="normal-color"
                  href="https://mediahaus.com.ar"
                >
                  {" "}
                  MediaHaus
                </a>{" "}
                - Powered by{" "}
                <a target="_blank" href="https://mediacore.app/">
                  {" "}
                  MediaCore
                </a>
                <br />
                <span style={{ fontSize: "0.7rem" }}>
                  Todos los derechos reservados ® {getCurrentYear()}
                </span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  ) : (
    ""
  )
}

export default connect(
  state => ({
    filters: state.properties.totalListFilters,
    api_key: state.settings.keys.tokko,
    investor: state.settings.investor,
    curFilters: state.properties.filters,
    modules: state.settings.modules,
    novelties: state.novelties.grid_novelties,
    property: state.properties.property,
    development: state.developments.development,
  }),
  null
)(Footer)
